export default __webpack_public_path__ + "static/media/a017-a.13bc94eb.svg";